import React, { createContext, useContext, useState, useEffect } from 'react';
import { getUserInfo } from '@/app/user';
import { useLocation } from 'react-router-dom';

interface BackgroundContextType {
  backgroundImage: string;
  updateBackground: (url: string) => void;
}

const BackgroundContext = createContext<BackgroundContextType | undefined>(undefined);

export function BackgroundProvider({ children }: { children: React.ReactNode }) {
  const [backgroundImage, setBackgroundImage] = useState<string>('');
  const location = useLocation();

  // 初始化时获取用户背景图片
  useEffect(() => {
    const fetchUserInfo = async () => {
      try {
        const userInfo = await getUserInfo();
        console.log('User info', JSON.stringify(userInfo));
        if (userInfo?.image_text) {
          console.log('获取到的背景图片地址: ', userInfo.image_text);
          setBackgroundImage(userInfo.image_text);
        }
      } catch (error) {
        console.error('获取用户信息失败:', error);
      }
    };

    fetchUserInfo();
  }, []);

  useEffect(() => {
    const fetchUserInfo = async () => {
      try {
        const userInfo = await getUserInfo();
        if (userInfo?.image_text) {
          setBackgroundImage(userInfo.image_text);
        }
      } catch (error) {
        console.error('获取用户信息失败:', error);
      }
    };
    fetchUserInfo();
  }, [location.search]); // 当 URL 参数变化时重新执行

  const updateBackground = (url: string) => {
    setBackgroundImage(url);
  };

  return <BackgroundContext.Provider value={{ backgroundImage, updateBackground }}>{children}</BackgroundContext.Provider>;
}

export function useBackground() {
  const context = useContext(BackgroundContext);
  if (context === undefined) {
    throw new Error('useBackground must be used within a BackgroundProvider');
  }
  return context;
}
